if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.click = false;
      this.$slider = false;
      this.init = false;
      this.$navItems = this.querySelectorAll('.slider-nav__item');
      this.$slides = this.querySelectorAll('.hero-slider__slide')
      if( !this.$navItems.length)
        return;

      var self = this;
      this.$navItems.forEach($elm => {
        $elm.addEventListener('click', self.onNavClick.bind(this));
      });

      var $firstSlide = this.$slides[0];

      if( $firstSlide.hasAttribute('data-video') ){
        const $video = $firstSlide.querySelector('.hero-slider__video');
        this.buildVideo($video);
      }

      this.navActiveClass = 'js-slider-nav-active';  

      document.addEventListener('js-window-interact', this.initSlider.bind(this), {once: true});
    }

    initSlider() {
      const autoplay = this.hasAttribute('data-autoplay') && this.hasAttribute('data-speed') ? this.getAttribute('data-speed'): false;

      let $slider = new Glide(this, {
        type: 'carousel',
        autoplay: autoplay,
        hoverpause: false,
        gap: 0
      });

      var self = this;
      $slider.on('run.before', function(e){
        const navCount = self.$navItems.length - 1;
        const dir = e.direction == ">" ? 1 : -1; 
        let index = $slider.index + dir;
        if( navCount == $slider.index && e.direction == ">" ){
          index = 0
        }else if( $slider.index == 0 && e.direction == "<" ){
          index = navCount;          
        } 

        if( !self.click ){
          self.setActiveSlide(index);          
        }
      });

      $slider.on('run.after', function(){
        const $currentSlide = self.querySelectorAll(`.hero-slider__slide:not(.glide__slide--clone)`)[$slider.index];
        self.playVideo($currentSlide);
      });

      $slider.on('mount.after', function(){
        const $currentSlide = self.querySelectorAll(`.hero-slider__slide:not(.glide__slide--clone)`)[$slider.index];
        self.classList.add('glide-active');
        self.prepareVideos();
      });

      $slider.mount();

      this.$slider = $slider;
    }

    onNavClick(e) {
      this.click = true;

      const $elm = e.target;
      const itr = $elm.getAttribute('rel');

      this.setActiveSlide(itr);

      this.click = false;
    }

    setActiveSlide(itr) {
      this.resetNavItems();
      this.setActiveNavItem(itr);
      this.$slider.go(`=${itr}`);
    }

    setActiveNavItem(itr) {
      this
        .$navItems[itr]
        .classList
        .add(this.navActiveClass);
    }

    resetNavItems() {
      this.$navItems.forEach($elm => {
        $elm.classList.remove(this.navActiveClass);
      });            
    }

    prepareVideos() {
      const $slides = this.querySelectorAll('.hero-slider__slide');

      const self = this;
      $slides.forEach(($elm, index) => {
        const $video = $elm.querySelector('.hero-slider__video');

        if( $video ){
          var video = self.buildVideo($video);

          if( $elm.classList.contains('glide__slide--active') ){
            self.playVideo($elm);
          }

        }
      });
    }

    buildVideo($video) {
        let video = document.createElement('video');
        video.src = $video.getAttribute('data-src');
        video.playsinline = true;
        video.loop = true;
        video.setAttribute('muted', "");
        video.setAttribute('playsinline', "");
        video.muted = true;

        $video.append(video);
    }

    playVideo($slide) {
      const $video = $slide.querySelector('.hero-slider__video video');
      if( $video ){
        $video.play();
      }
    }
  }

  customElements.define('hero-slider', HeroSlider);
}